import * as React from "react"
import { useEffect } from "react"
import { Grid } from "@mui/material"

import { ADMIN_ROUTES } from "@constants"
import { clearAdminSkusSignals } from "./@signals"
import AdminSkuDrawer from "./DrawerSKU"
import AdminSkuFilters from "./Filters"
import AdminSkuMappingTable from "./Mappings"
import AdminSkuModal from "./ModalSKU"
import AdminSkuTable from "./Table"
import PageWrapper from "../../@PageWrapper"


export default function AdminSkuPage() {

    useEffect(() => {
        return clearAdminSkusSignals
    }, [])

    return <PageWrapper
        head={`${ADMIN_ROUTES.TITLE} | ${ADMIN_ROUTES.SKU_TITLE}`}
        title={ADMIN_ROUTES.SKU_TITLE}
        filters={<AdminSkuFilters />}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <AdminSkuTable />
            </Grid>

            <Grid item xs={12}>
                <AdminSkuMappingTable/>
            </Grid>
        </Grid>

        <AdminSkuDrawer />
        <AdminSkuModal />
    </PageWrapper>
}